// Shared Dimension Stepper Component
// Used by Electrical and Thermal sections for 1D → 2D → 3D navigation

export default function DimensionStepper({ dimension, onDimensionChange, has3DData = true, ...rest }) {
  return (
    <div className="dimension-stepper" {...rest}>
      {/* 1D View */}
      <button
        className={`dimension-btn ${dimension === '1d' ? 'active' : ''}`}
        onClick={() => onDimensionChange('1d')}
      >
        <span className="dim-icon">●</span>
        <div className="dim-info">
          <div className="dim-label">Value</div>
          <div className="dim-sublabel">Single Metric</div>
        </div>
      </button>
      
      <div className="stepper-line"></div>
      
      {/* 2D View */}
      <button
        className={`dimension-btn ${dimension === '2d' ? 'active' : ''}`}
        onClick={() => onDimensionChange('2d')}
      >
        <span className="dim-icon">◧</span>
        <div className="dim-info">
          <div className="dim-label">2D Plot</div>
          <div className="dim-sublabel">Line Charts</div>
        </div>
      </button>
      
      {/* Conditional 3D View */}
      {has3DData && (
        <>
          <div className="stepper-line"></div>
          
          <button
            className={`dimension-btn ${dimension === '3d' ? 'active' : ''}`}
            onClick={() => onDimensionChange('3d')}
          >
            <span className="dim-icon">◰</span>
            <div className="dim-info">
              <div className="dim-label">Surface Plot</div>
              <div className="dim-sublabel">3D Landscape</div>
            </div>
          </button>
        </>
      )}
    </div>
  )
}
